<template>
<nav class="navbar-about" id="navbar" v-show="isNavbarVisible">
        <div class="navbar-about__wrapper">
          <ul class="m-0 p-0">
            <li
              class="navbar-about__item"
              data-letters="Business Background"
              :class="{ active: isActive('business-background') }"
            >
              <a class="navbar-about__link" href="#business-background">
                <i class="fas fa-circle"></i>
              </a>
            </li>
            <li
              class="navbar-about__item"
              data-letters="Milestones"
              :class="{ active: isActive('milestones') }"
            >
              <a class="navbar-about__link" href="#milestones">
                <i class="fas fa-circle"></i>
              </a>
            </li>
            <li
              class="navbar-about__item"
              data-letters="Management Team"
              :class="{ active: isActive('management-team') }"
            >
              <a class="navbar-about__link" href="#management-team">
                <i class="fas fa-circle"></i>
              </a>
            </li>
            <li
              class="navbar-about__item"
              data-letters="Our team"
              :class="{ active: isActive('our-team') }"
            >
              <a class="navbar-about__link" href="#our-team">
                <i class="fas fa-circle"></i>
              </a>
            </li>
          </ul>
        </div>
      </nav>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const isNavbarVisible = ref(true);
const activeSection = ref();
const checkIfHideNavIsInView = async () => {
  // const hideNav = document.getElementById("hideNav");
  const hideNav = document.querySelector(".hideNav");
  if (!hideNav) return;

  const rect = hideNav.getBoundingClientRect();
  isNavbarVisible.value = !(rect.top <= 100 && rect.bottom >= 0);
};

const handleScroll = async () => {
  const sections = [
    "business-background",
    "milestones",
    "management-team",
    "our-team",
  ];

  let currentSection = "";
  sections.forEach((sectionId) => {
    const element = document.getElementById(sectionId);
    if (!element) return;

    const rect = element.getBoundingClientRect();
    if (
      rect.top <= window.innerHeight / 2 &&
      rect.bottom >= window.innerHeight / 2
    ) {
      currentSection = sectionId;
    }
  });

  activeSection.value = currentSection;
};

const isActive = (id) => activeSection.value === id;
// Lifecycle Hooks
onMounted(() => {
  window.addEventListener("scroll", checkIfHideNavIsInView);
  checkIfHideNavIsInView();

  window.addEventListener("scroll", handleScroll);
  handleScroll();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", checkIfHideNavIsInView);
  window.removeEventListener("scroll", handleScroll);
});

</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";
.navbar-about {
  position: fixed;
  top: 35%;
  right: 50px;
  z-index: 1;
  height: 180px;
  border-radius: 25px;
  background: rgb(126 126 126 / 34%);
  backdrop-filter: blur(5px);
  width: fit-content;

  @include media-breakpoint-down(md) {
    right: 20px;
  }

  .navbar-about__wrapper {
    padding: 0 10px;
    margin: 0;
  }

  .navbar-about__item {
    position: relative;
    margin-bottom: 18px;
    display: flex;
    justify-content: end;

    &:after {
      content: "";
      position: absolute;
      bottom: -22px;
      left: 4.5px;
      height: 20px;
      width: 1px;
      background: $gray-1;
    }

    &:last-child {
      margin-bottom: 0px;

      &:after {
        display: none;
      }
    }

    &::before {
      position: absolute;
      margin-right: 30px;
      top: 8px;
      content: attr(data-letters);
      font-size: px-to-rem(14);
      color: $white;
      background-color: $black;
      border-radius: 25px;
      padding: 3px 15px;
      opacity: 0;
      text-wrap-mode: nowrap;
      @include transition();
    }

    &.active {
      .navbar-about__link {
        i {
          color: $yellow-ci;
        }
      }
    }

    @include hover {
      &::before {
        opacity: 1;
      }

      .navbar-about__link {
        i {
          color: $black;
        }
      }
    }
  }

  .navbar-about__link {
    i {
      font-size: px-to-rem(10);
      color: $gray-1;
    }
  }
}

</style>